<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->
// Simple Performance Optimization for Gradient
document.addEventListener('DOMContentLoaded', function() {
  const announcementBar = document.querySelector('#shopify-section-sections--24996860559634__announcement_bar_kpGqkK .announcement-bar');
  
  if (announcementBar) {
    // Performance optimization: pause animation when not visible
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.animationPlayState = 'running';
        } else {
          entry.target.style.animationPlayState = 'paused';
        }
      });
    }, { threshold: 0.1 });
    
    observer.observe(announcementBar);
  }
});